var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "header" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticClass: "logo" },
            [
              _c("router-link", { attrs: { to: "/index" } }, [
                _c("img", {
                  staticClass: "menu_bar_customer_logo_image",
                  attrs: { src: _vm.logoImage }
                })
              ])
            ],
            1
          ),
          _vm._t("default")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }